import React, { useState } from 'react'
import { Button, Col, Row, Modal, Form } from 'react-bootstrap'
import { useForm, ValidationError } from '@formspree/react'
import Swal from 'sweetalert2'
import ThreeDots from '../loading_state/ThreeDots'

const FleetBooking = ({ tourdetails }) => {
  const [showModal, setShowModal] = useState(false)
  const [state, handleSubmit] = useForm('mjvdgzng')
  if (state.succeeded) {
    Swal.fire(
      'welcome!',
      `you have successfully reserved ${tourdetails.name}`,
      'success'
    )
    return (
      <div
        style={{
          fontStyle: 'italic',
          backgroundColor: 'green',
          padding: '10px',
          color: 'white',
          borderRadius: '40px',
        }}
      >
        Thanks for choosing jetra travel hub
      </div>
    )
  }
  const handleShowModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  return (
    <section className='booking__card py-5 px-4'>
      <div className='heading text-center mb-4'>
        <h3>Online Booking </h3>
      </div>
      <h4
        style={{
          fontStyle: 'italic',
          backgroundColor: '#cc3300',
          padding: '6px',
          color: 'white',
          borderRadius: '40px',
        }}
      >
        price from ${tourdetails.price}
      </h4>
      <h3>book {tourdetails.name}</h3>
      <div className='d-flex justify-content-center pt-4'>
        <Button className='find__now' onClick={handleShowModal}>
          <div>
            <span className='transition' />
            <span className='label'>Book Now</span>
          </div>
        </Button>
      </div>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Book {tourdetails.name} Now </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group>
              <Form.Label>name</Form.Label>
              <ValidationError
                prefix='name'
                field='name'
                errors={state.errors}
              />
              <Form.Control type='text' name='name' />
            </Form.Group>
            <Form.Group>
              <Form.Label>email</Form.Label>
              <ValidationError
                prefix='Email'
                field='email'
                errors={state.errors}
              />
              <Form.Control htmlFor='email' type='email' name='email' />
            </Form.Group>
            <Form.Group>
              <Form.Label>phone number</Form.Label>
              <ValidationError
                prefix='contact'
                field='contact'
                errors={state.errors}
              />
              <Form.Control type='text' name='contact' id='contact' />
            </Form.Group>
            <Form.Group>
              <Form.Label>Number of Passangers</Form.Label>
              <ValidationError
                prefix='number_of_passangers'
                field='number_of_passangers'
                errors={state.errors}
              />
              <Form.Control type='number' name='number_of_passangers' />
            </Form.Group>
            <Form.Group>
              <Form.Label>Pick Up Address</Form.Label>
              <ValidationError
                prefix='pick-up'
                field='pick-up'
                errors={state.errors}
              />
              <Form.Control type='text' name='pick-up' />
            </Form.Group>
            <Form.Group>
              <Form.Label>Drop Off Address</Form.Label>
              <ValidationError
                prefix='drop-off'
                field='drop-off'
                errors={state.errors}
              />
              <Form.Control
                type='text'
                placeholder='drop off address building...'
                name='drop-off'
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Car Model</Form.Label>
              <ValidationError
                prefix='car-model'
                field='car-model'
                errors={state.errors}
              />
              <Form.Control
                type='text'
                placeholder='Car model...'
                name='car-model'
                defaultValue={tourdetails.name}
              />
            </Form.Group>
            <br />
            <Button variant='primary' type='submit' disabled={state.submitting}>
              {state.submitting ? <ThreeDots /> : 'Submit'}
            </Button>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  )
}

export default FleetBooking
